import {
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import { queriesPayerRows, queriesPayers } from "@query";
import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { selectorPayerEngagementsFromV3 } from "@selectors/selectorPayerEngagementsFromV3";
import { WSQueries } from "../../../query/WSQuery";
import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import { selectorPayerDisplayName } from "../../../shared/selectors/selectorPayerDisplayName";
import { selectorPayerPayeeEngagementName } from "../../Payees/selectors/selectorPayerPayeeEngagementName";
import { usePayerEngagementHistoryResources } from "../hooks/usePayerEngagementHistoryResources";
import { getPayerEngagementUrl, PAYERS_PATH } from "../paths";

export const RoutePayerEngagementHistory: React.FC = () => {
  const history = useHistory();
  const match = useRouteMatch<{ engagementId: string; payerId: string }>();
  const payerId = match.params.payerId;
  const engagementId = match.params.engagementId;

  // v3 read: the search row carries name/isDefault (see
  // selectorPayerEngagementsFromV3) — the lean CRUD PayerEngagement has no
  // isDefault field, so it can't satisfy selectorPayerPayeeEngagementName.
  const queryPayerRows = queriesPayerRows.searchPayerRows.useQuery({
    filter: { id: { eq: payerId } }
  });
  const queryPayer = queriesPayers.getPayer.useQuery(
    { payerId },
    { retry: false }
  );

  const historyResources = usePayerEngagementHistoryResources(engagementId);

  return (
    <WSPage>
      <WSQueries queries={{ queryPayerRows, queryPayer }}>
        {({ queryPayerRowsData, queryPayerData }) => {
          const engagement = selectorPayerEngagementsFromV3(
            queryPayerRowsData.data?.[0]
          ).find(e => e.payerPayeeEngagementId === engagementId);

          const engagementName = engagement
            ? selectorPayerPayeeEngagementName(engagement, true)
            : undefined;

          const payerName = selectorPayerDisplayName(queryPayerData);

          return (
            <>
              <WSPageToolbar
                title="Assignment history"
                breadcrumbs={[
                  {
                    label: "Clients",
                    onClick: () => {
                      history.push(PAYERS_PATH);
                    }
                  },
                  {
                    label: payerName,
                    onClick: () => {
                      history.push(PAYERS_PATH + `/${payerId}`);
                    }
                  },
                  {
                    label: engagementName || "Assignment",
                    onClick: () => {
                      history.push(
                        getPayerEngagementUrl(payerId, engagementId)
                      );
                    }
                  },
                  {
                    label: "Assignment history"
                  }
                ]}
              />

              <WSGrid>
                <WSGrid.Item span={{ l: "8" }}>
                  <WSList gap="2XL">
                    <ResourceHistory resources={historyResources} />
                  </WSList>
                </WSGrid.Item>
              </WSGrid>
            </>
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
